import { fetchFromAPI } from '@/Utils/stripeHooks/helpers';
import { useQuery } from 'react-query';

const fetchClientSecret = async () => {
  const data = await fetchFromAPI<{ client_secret: string }>(
    '/api/v1/payment_methods/setup_intent',
    'POST',
  );

  return data.client_secret || '';
};

export const useClientSecretSetupIntent = () => {
  return useQuery({
    queryKey: ['clientSecret'],
    queryFn: fetchClientSecret,
    staleTime: 0,
    cacheTime: 0,
    refetchOnWindowFocus: false,
    retry: 0,
  });
};
